import React, { useState, useRef, useCallback, memo } from "react";
import Nav from "../components/Nav";
import { useNavContext } from "../context/NavContext";
import Breadcrumb from "../components/Breadcrumb";

export default function CartaIngresos() {
  // ===== Estado =====
  const [ciudad, setCiudad] = useState("El Salto, Jal.");
  const [fechaLarga, setFechaLarga] = useState("martes, 4 de febrero de 2025");

  const [remitente, setRemitente] = useState("Víctor García");
  const [remitentePuesto, setRemitentePuesto] = useState("Administración");

  const [empresa, setEmpresa] = useState(
    "UNIFICACIÓN PARA LA AUTOMATIZACIÓN SA DE CV"
  );
  const [trabajador, setTrabajador] = useState("Mora Ramírez José Antonio");
  const [cargoTrabajador, setCargoTrabajador] = useState(
    "Automatización y Diseño"
  );
  const [salario, setSalario] = useState("6,044.40");
  const [ingresoExtra, setIngresoExtra] = useState("15,000");

  // Datos pie derecho
  const [tel1, setTel1] = useState("(33) 3619 2439");
  const [tel2, setTel2] = useState("33 1602 2358");
  const [web, setWeb] = useState("www.iciamex.com");
  const [mail, setMail] = useState("contacto@iciamex.com");
  const [dir, setDir] = useState(
    "Lic. Ramiro Hernández 448\nLas Pintitas, El Salto, Jal."
  );

  const [isEditing, setIsEditing] = useState(true);

  const logoSrc = "/img/logo-comercial.svg";
  const { proximasAVencer, proximosEventos } = useNavContext?.() || {};

  // ===== Estilos (pantalla) =====
  const GAP = 20;

  const outer = {
    background: "#f5f7fa",
    minHeight: "100dvh",
    paddingBlock: GAP,
  };

  const page = {
    maxWidth: 1220,
    margin: `${GAP}px auto`, // ↑↓ = 20px, ←→ = auto (centrado)
    background: "#fff",
    padding: "48px 72px 56px",
    fontFamily: "Arial, Helvetica, sans-serif",
    color: "#111",
    lineHeight: 1.6,
    boxShadow: "0 2px 16px rgba(0,0,0,0.06)",
    minHeight: 1280,
    display: "flex",
    flexDirection: "column",
    position: "relative",
  };

  const content = {
    maxWidth: 980,
    margin: "0 auto",
    display: "flex",
    flexDirection: "column",
    flex: 1,
    minHeight: "100%",
  };

  const header = {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "space-between",
    marginBottom: 12,
  };

  const cityDate = { textAlign: "right", fontSize: 18, fontWeight: 700 };

  // ===== Regla superior =====
  const ruleRow = {
    display: "flex",
    alignItems: "center",
    marginTop: 18,
    marginBottom: 28,
  };
  // Solo línea azul y al 100%
  const blueRule = {
    height: 8,
    width: "100%",
    background: "#0A6CA9",
    borderRadius: 2,
  };

  const atn = {
    marginTop: 18,
    marginBottom: 16,
    fontSize: 20,
    fontWeight: 700,
  };
  const p = { fontSize: 22, margin: "12px 0", textAlign: "justify" };

  // ===== Bloque inferior (firma/contacto) en pantalla =====
  const bottom = {
    alignItems: "end",
    marginTop: 40,
  };

  // >>> Firma centrada respecto a TODA la página (sin tocar la columna derecha)
  const leftSign = {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    textAlign: "center",
    gridColumn: "1 / -1", // ocupa toda la fila del grid
    justifySelf: "center", // centrada dentro del grid
    width: "min(70%, 420px)", // ancho controlado y centrado
  };
  const signLine = {
    width: 300,
    height: 2,
    background: "#111",
    margin: "0 auto 14px",
  };
  const nameBig = { fontSize: 24, fontWeight: 800 };
  const role = { fontSize: 20, marginBottom: 18 };
  const empresaBig = { fontSize: 22, fontWeight: 800, letterSpacing: 0.2 };

  const rightInfo = {
    textAlign: "right",
    fontSize: 16,
  };

  // Franja inferior (pantalla)
  const footerBarsWrap = {
    marginTop: 0,
    display: "flex",
    width: "100%",
    height: 22,
  };
  const footerBlue = { background: "#0A6CA9", width: "60%" };
  const footerDark = { background: "#3D3D3D", width: "40%" };

  // ===== Editable =====
  const Editable = memo(
    function Editable({
      enabled,
      initialText,
      onCommit,
      underline = false,
      bold = false,
      ariaLabel,
      style,
      block = false,
      color,
    }) {
      const ref = useRef(null);
      const inited = useRef(false);
      const [focused, setFocused] = useState(false);

      const setNode = useCallback(
        (node) => {
          if (!node) return;
          ref.current = node;
          if (!inited.current) {
            node.textContent = initialText || "";
            inited.current = true;
          }
        },
        [initialText]
      );

      const handleBlur = useCallback(() => {
        setFocused(false);
        if (onCommit && ref.current) onCommit(ref.current.textContent || "");
      }, [onCommit]);

      const handleFocus = useCallback(() => setFocused(true), []);
      const handleKeyDown = useCallback(
        (e) => {
          if (!block && e.key === "Enter") e.preventDefault();
        },
        [block]
      );

      const handlePaste = useCallback(
        (e) => {
          if (!enabled) return;
          e.preventDefault();
          const text = (e.clipboardData || window.clipboardData).getData(
            "text"
          );
          document.execCommand("insertText", false, text);
        },
        [enabled]
      );

      const redBase = "#ef4444";
      const redLight = "#fca5a5";
      const redBg = "#fef2f2";

      const editableBox = enabled
        ? {
            background: redBg,
            border: `1px dashed ${focused ? redBase : redLight}`,
            boxShadow: focused ? "0 0 0 2px rgba(239,68,68,.10)" : "none",
            borderRadius: 6,
            transition: "box-shadow .15s ease, border-color .15s ease",
          }
        : {};

      const sizing =
        enabled && block
          ? { display: "inline-block", padding: "4px 6px", minHeight: 28 }
          : enabled
          ? { display: "inline-block", padding: "0 4px", lineHeight: 1.2 }
          : { display: "inline" };

      return (
        <span
          ref={setNode}
          role="textbox"
          aria-label={ariaLabel}
          contentEditable={enabled}
          suppressContentEditableWarning
          spellCheck={false}
          className={`ci-editable${block ? " ci-block" : ""}`}
          onBlur={enabled ? handleBlur : undefined}
          onFocus={enabled ? handleFocus : undefined}
          onKeyDown={enabled ? handleKeyDown : undefined}
          onPaste={enabled ? handlePaste : undefined}
          style={{
            boxSizing: "border-box",
            textDecoration: underline ? "underline" : "none",
            fontWeight: bold ? 800 : undefined,
            color: color || "inherit",
            cursor: enabled ? "text" : "default",
            verticalAlign: "baseline",
            ...sizing,
            ...editableBox,
            ...style,
          }}
        />
      );
    },
    () => true
  );

  // ===== Imprimir =====
  const handlePrint = () => {
    const wasEditing = isEditing;
    setIsEditing(false); // oculta bordes de edición

    requestAnimationFrame(() => {
      const pageNode = document.querySelector(".ci-page");
      if (!pageNode) return;

      const html = `
<!doctype html>
<html>
<head>
<meta charset="utf-8" />
<title>Carta Ingresos</title>
<style>
  /* Controlamos márgenes con .ci-content */
  @page { size: A4; margin: 0; }

  * { -webkit-print-color-adjust: exact; print-color-adjust: exact; }
  html, body { height: 100%; }
  body {
    margin:0;
    font-family: Arial, Helvetica, sans-serif;
    color:#111; line-height:1.5; font-size:13.5px;
    background:#fff;
  }

  .print-sheet{ position:relative; height:297mm; overflow:hidden; }

  /* Página sin sombras ni paddings en impresión */
  .ci-page{
    box-shadow:none !important;
     margin: 20px !important;
  padding: 20px !important;
  background:#fff !important;
    position:relative;
    height:297mm;
    display:flex; flex-direction:column;
    overflow:hidden;
  }

  /* Márgenes útiles: 6mm arriba, 12mm lados y abajo */
  .ci-content{
    max-width:none;
    margin:6mm 12mm 12mm;
    padding: 0; /* que el footer no tape texto */
    display:flex; flex-direction:column; min-height:100%;
    box-sizing:border-box;
  }

  .ci-header{ margin-bottom: 6px !important; }

  /* Ajustes visuales de impresión (mismos nombres que usas) */
  .ci-citydate{ font-size:16px; font-weight:700; }
  .ci-atn{ font-size:16px; margin-top:14px; margin-bottom:6px; }
  .ci-p{ font-size:13px; line-height:1.5; margin-top:10px; margin-bottom:6px; text-align:justify; }

  .ci-bluebar{ width:100%; height:8px; background:#0A6CA9; border-radius:2px; }

  .ci-bottom{
  display: grid;
  grid-template-columns: 2fr 1fr; /* mantén tus proporciones */
  gap: 18px;
  align-items: end;
  margin-top: 25px;
}
.ci-left{
  grid-column: 1 / -1;                     /* ocupa toda la fila */
  display:flex; flex-direction:column;
  align-items:center; text-align:center;
  margin: 0 auto 10mm;                      /* centrada y separada del footer */
  width: auto;
  max-width: 420px;
}
.ci-signline{
  width: 70%;
  max-width: 320px;
  height: 2px;
  background:#111;
  margin: 0 auto 14px;                      /* centrada */
}
.ci-firm-name{ font-size: 15px; font-weight: 800; text-align: center; }
.ci-firm-role{ font-size: 12px; text-align: center; }
.ci-empresa{   font-size: 12px; text-align: center; }
.ci-right{
  grid-column: 1;             /* col. izquierda del grid */
  justify-self: start;        /* pegado al margen izquierdo útil */
  align-self: end;
  text-align: left !important;/* anula el inline de pantalla */
  white-space: pre-line;
  margin-bottom: 19px;        /* respiro con la franja inferior */
  font-size: 12.5px;
  line-height: 1.35;
}
  /* Quitar por completo estilos de edición */
  .ci-editable{
    background:transparent;
    border:none;
    box-shadow:none;
    padding:0;
    display:inline;
  }
  .ci-editable.ci-block{ display:inline; }

  /* Franja inferior ocupando todo el ancho útil entre márgenes */
 .footer-bars{
  position: fixed;
  inset: auto 0 0 0; /* pega a ambos lados y al borde inferior */
  height: 22px;
  display: flex;
  margin: 0;
  z-index: 9999;
  }
  .footer-blue{ background:#0A6CA9; width:60%; }
  .footer-dark{ background:#3D3D3D; width:40%; }

</style>
</head>
<body>
  <div class="print-sheet">${pageNode.outerHTML}</div>
</body>
</html>`.trim();

      // Imprimir en un iframe oculto (sin abrir ventana nueva)
      const iframe = document.createElement("iframe");
      Object.assign(iframe.style, {
        position: "fixed",
        right: 0,
        bottom: 0,
        width: "0",
        height: "0",
        border: 0,
      });
      document.body.appendChild(iframe);

      const doc = iframe.contentDocument || iframe.contentWindow.document;
      doc.open();
      doc.write(html);
      doc.close();

      let finished = false;
      const cleanup = () => {
        if (finished) return;
        finished = true;
        setIsEditing(wasEditing);
        setTimeout(() => iframe.remove(), 0);
      };

      iframe.onload = () => {
        setTimeout(() => {
          iframe.contentWindow.focus();
          iframe.contentWindow.print();
        }, 0);
      };

      iframe.contentWindow.addEventListener("afterprint", cleanup, {
        once: true,
      });
      setTimeout(cleanup, 5000); // fallback por si afterprint no dispara
    });
  };

  return (
    <>
      <Nav
        handleSearch={() => {}}
        proximasAVencer={proximasAVencer}
        proximosEventos={proximosEventos}
      />

      {/* Barra superior */}
      <div
        className="task-filters"
        style={{
          display: "flex",
          alignItems: "center",
          flexWrap: "nowrap", // todo en una sola fila
          gap: 8,
          borderBottom: "none", // quita la línea
        }}
      >
        {/* Izquierda: Breadcrumb */}
        <div
          style={{
            flex: 1,
            padding: "0 4px",
            minHeight: 36, // mismo alto visual que tus headers
            display: "flex",
            alignItems: "center",
          }}
        >
          <Breadcrumb
            aliases={{
              personalizacion: "Personalizacion",
              "carta-poder": "Carta Poder",
            }}
          />
        </div>

        {/* Derecha: Botones */}
        <div
          className="task-filters-right"
          style={{ display: "flex", alignItems: "center", gap: 10 }}
        >
          <button
            className="exportar-button"
            onClick={handlePrint}
            title="Imprimir"
          >
            Imprimir
          </button>
          <button
            className="new-task-button"
            onClick={() => setIsEditing((v) => !v)}
            title={isEditing ? "Guardar" : "Editar"}
          >
            {isEditing ? "Guardar" : "Editar"}
          </button>
        </div>
      </div>

      {/* Página */}
      <div style={outer}>
        <div style={page} className="ci-page">
          <div style={content} className="ci-content">
            {/* Encabezado */}
            <div style={header} className="ci-header">
              <img src={logoSrc} alt="Logo" style={{ height: 50 }} />
              <div style={cityDate} className="ci-citydate">
                <div>
                  <Editable
                    enabled={isEditing}
                    initialText={ciudad}
                    onCommit={setCiudad}
                    ariaLabel="Ciudad"
                    block
                  />
                </div>
                <div style={{ marginTop: 6 }}>
                  <Editable
                    enabled={isEditing}
                    initialText={fechaLarga}
                    onCommit={setFechaLarga}
                    ariaLabel="Fecha"
                    block
                  />
                </div>
              </div>
            </div>

            {/* Única línea azul */}
            <div style={ruleRow}>
              <div style={blueRule} className="ci-bluebar" />
            </div>

            {/* ATN */}
            <div style={atn} className="ci-atn">
              ATN:&nbsp; A QUIÉN CORRESPONDA
            </div>

            {/* Cuerpo */}
            <p style={p} className="ci-p">
              Reciba un cordial saludo. Por medio de la presente, yo{" "}
              <Editable
                enabled={isEditing}
                initialText={remitente}
                onCommit={setRemitente}
                underline
                bold
                ariaLabel="Remitente"
              />
              , director administrativo de la empresa{" "}
              <Editable
                enabled={isEditing}
                initialText={empresa}
                onCommit={setEmpresa}
                underline
                bold
                ariaLabel="Empresa"
              />
              , DECLARO que el trabajador{" "}
              <Editable
                enabled={isEditing}
                initialText={trabajador}
                onCommit={setTrabajador}
                underline
                bold
                ariaLabel="Trabajador"
              />{" "}
              con cargo (
              <Editable
                enabled={isEditing}
                initialText={cargoTrabajador}
                onCommit={setCargoTrabajador}
                underline
                bold
                ariaLabel="Cargo trabajador"
              />
              ) y contrato laboral indefinido recibe un salario de{" "}
              <Editable
                enabled={isEditing}
                initialText={salario}
                onCommit={setSalario}
                underline
                bold
                ariaLabel="Salario"
              />{" "}
              mensualmente que es reportado en su recibo de nómina. Además de
              los{" "}
              <Editable
                enabled={isEditing}
                initialText={salario}
                onCommit={setSalario}
                underline
                bold
                ariaLabel="Salario repetido"
              />{" "}
              mensuales, percibe un ingreso extra mensual de{" "}
              <Editable
                enabled={isEditing}
                initialText={ingresoExtra}
                onCommit={setIngresoExtra}
                underline
                bold
                ariaLabel="Ingreso extra"
              />{" "}
              pesos, mismos que son pagados en efectivo.
            </p>

            <p style={p} className="ci-p">
              Se adjunta recibo de nómina.
            </p>

            <p style={p} className="ci-p">
              Sin más por el momento agradezco su ayuda y quedo de usted para
              cualquier aclaración.
            </p>

            {/* Spacer controlado */}
            <div className="ci-spacer" />

            {/* Firmas / Datos */}
            <div style={bottom} className="ci-bottom">
              <div style={leftSign} className="ci-left">
                <div style={signLine} className="ci-signline" />
                <div style={nameBig} className="ci-firm-name">
                  <Editable
                    enabled={isEditing}
                    initialText={remitente}
                    onCommit={setRemitente}
                    bold
                    ariaLabel="Nombre firma"
                  />
                </div>
                <div style={role} className="ci-firm-role">
                  <Editable
                    enabled={isEditing}
                    initialText={remitentePuesto}
                    onCommit={setRemitentePuesto}
                    ariaLabel="Puesto firma"
                  />
                </div>
                <div style={empresaBig} className="ci-empresa">
                  <Editable
                    enabled={isEditing}
                    initialText={empresa}
                    onCommit={setEmpresa}
                    bold
                    ariaLabel="Empresa firma"
                    style={{ whiteSpace: "nowrap" }}
                  />
                </div>
              </div>

              <div style={rightInfo} className="ci-right">
                <div>
                  <Editable
                    enabled={isEditing}
                    initialText={tel1}
                    onCommit={setTel1}
                    ariaLabel="Teléfono 1"
                  />
                  <br />
                  <Editable
                    enabled={isEditing}
                    initialText={tel2}
                    onCommit={setTel2}
                    ariaLabel="Teléfono 2"
                  />
                </div>
                <div>
                  <Editable
                    enabled={isEditing}
                    initialText={web}
                    onCommit={setWeb}
                    ariaLabel="Web"
                  />
                  <br />
                  <Editable
                    enabled={isEditing}
                    initialText={mail}
                    onCommit={setMail}
                    ariaLabel="Correo"
                  />
                </div>
                <div>
                  <Editable
                    enabled={isEditing}
                    initialText={dir}
                    onCommit={setDir}
                    ariaLabel="Dirección"
                    block
                  />
                </div>
              </div>
            </div>

            {/* === Barras pie (dentro de .ci-content) === */}
            <div style={footerBarsWrap} className="footer-bars">
              <div style={footerBlue} className="footer-blue" />
              <div style={footerDark} className="footer-dark" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
